export default {
  id: "marble",
  background: "/ambient/templates/marble/ambient-marble.jpg",

  album: {
    x: 197,
    y: 30,
    width: 739,
    height: 738,
    rotation: -7
  },

  setlist: {
    x: 1681,
    y: 19,
    width: 559,
    height: 760,
    rotation: 4
  },

  logo: {
    x: 1718,
    y: 42,
    width: 420,
    height: 92,
    rotation: 4
  },

  info: {
    x: 934,
    y: 0,
    width: 750,
    height: 800,
    rotation: 0
  },

  clock: {
    x: 2291,
    y: 40,
    width: 223,
    height: 33,
    rotation: 0
  }
};
